"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareLinkButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_react_1 = require("@streem/ui-react");
const react_1 = require("react");
const use_share_link_1 = require("../../../../hooks/use_share_link");
const use_media_breakpoint_1 = require("../../../../hooks/use_media_breakpoint");
const theme_1 = __importDefault(require("@streem/ui-react/src/styles/theme"));
const ShareLinkButton = ({ roomSid, anonymousShareEnabled, companyName }) => {
    const containerRef = (0, react_1.useRef)(null);
    const [hover, setHover] = (0, react_1.useState)(false);
    const [showPopup, setShowPopup] = (0, react_1.useState)(false);
    const [popupPosition, setPopupPosition] = (0, react_1.useState)({
        top: 0,
        right: 0,
    });
    const handleMouseEnter = (0, react_1.useCallback)(() => {
        setHover(true);
    }, []);
    const handleMouseLeave = (0, react_1.useCallback)(() => {
        setHover(false);
    }, []);
    const handleShareButtonClick = (0, react_1.useCallback)(() => {
        const shadowOffset = -28;
        const verticalOffset = -29;
        setPopupPosition({
            top: verticalOffset,
            right: shadowOffset,
        });
        setShowPopup(true);
        setHover(false);
    }, []);
    const [link, refreshLink] = (0, use_share_link_1.useShareLink)({ roomSid, anonymousShareEnabled });
    const { isSmallScreen } = (0, use_media_breakpoint_1.useMediaBreakpoint)();
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(ui_react_1.Tooltip, Object.assign({ placement: "left", fallbackPlacements: ['left', 'top'], showTooltip: hover, message: (0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ size: "small", style: { whiteSpace: 'nowrap' } }, { children: "Create share link" })), borderRadius: "6px" }, { children: (0, jsx_runtime_1.jsx)(ShareLinkIconButton, { label: 'Create share link', iconName: 'ShareIconThick', fill: theme_1.default.colors.grey60, iconSize: "25", onClick: handleShareButtonClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ ref: containerRef, style: { position: 'relative' } }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.ShareLinkPopup, { open: showPopup, position: popupPosition, onClose: () => setShowPopup(false), containerRef: containerRef, companyName: companyName, link: link || '', refreshLink: refreshLink, anonymousShareEnabled: anonymousShareEnabled, cardSize: isSmallScreen ? '365' : '415' }) }))] }));
};
exports.ShareLinkButton = ShareLinkButton;
const ShareLinkIconButton = (0, ui_react_1.styled)(ui_react_1.IconButton) `
    opacity: 0.9;
    margin-bottom: 8px;

    &:active {
        opacity: 0.64;
        transform: scale(0.92);
    }
    &:hover:enabled {
        cursor: pointer;
        background: #f2f8fe;
    }
`;
//# sourceMappingURL=share_link_button.js.map